import { GET_LED_MAPPING_FAILURE, GET_LED_MAPPING_SUCCESS } from '../constants/MTag';
import { onSuccess, onFailure } from './common';

const initStat = { data: [], error: false, errorData: '', isLoading: true };

export default (state = initStat, action) => {
	switch (action.type) {
		case GET_LED_MAPPING_SUCCESS:
			return onSuccess(state, action);
		case GET_LED_MAPPING_FAILURE:
			return onFailure(state, action);
		default:
			return { ...state };
	}
};
